// extracted by mini-css-extract-plugin
export var footer = "_o1-5";
export var fulfillmentInput = "_o1-0";
export var shipDateInput = "_o1-1";
export var shipmentModal = "_o1-2";
export var shipmentModalContent = "_o1-3";
export var tableContainer = "_o1-4";